import styled from '@emotion/styled';
import React from 'react';
import { useButton } from '~Hooks';
import Icon from '~ComponentsImproved/Icon';
import linkIcon from '~/Assets/icons/link.svg';
import { Box } from '~Styles';

const OngoingChequeBlock = styled.div<{
  gridColumnStart: number;
  offsetMinutes: number;
  durationMinutes: number;
  touching?: boolean;
  isPastDue?: boolean;
  isSelected?: boolean;
}>`
  position: absolute;
  left: ${(props) =>
    64 +
    (props.gridColumnStart - 2) * 61 +
    (props.offsetMinutes / 30) *
      61}px; /* 64px label + column position * (60px + 1px gap) + minute offset */
  width: ${({ durationMinutes }) =>
    (durationMinutes / 30) * 61 +
    'px'}; /* Convert minutes to pixels: each 30 min = 61px (60px + 1px gap) */
  top: 4px;
  bottom: 4px;
  background: repeating-linear-gradient(
    45deg,
    rgba(102, 126, 234, 0.6),
    rgba(102, 126, 234, 0.6) 10px,
    rgba(118, 75, 162, 0.6) 10px,
    rgba(118, 75, 162, 0.6) 20px
  );
  border-radius: 6px;
  padding: 2px 8px;
  color: var(--colorWhite);
  font-size: 12px;
  font-weight: 500;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
  justify-content: center;
  z-index: 4;
  box-sizing: border-box;
  border-left: 3px solid rgba(102, 126, 234, 0.8);
  /* Show red border when past due */
  outline: ${({ isPastDue, isSelected }) =>
    isSelected
      ? '2px solid var(--colorWhite)'
      : isPastDue
      ? '2px solid var(--colorUIRed)'
      : '2px solid transparent'};
  opacity: 0.9;
  cursor: pointer;
  transition: all 0.2s;
`;

interface Props {
  chequeId: string;
  tableId: string;
  gridColumnStart: number;
  offsetMinutes: number;
  durationMinutes: number;
  isPastDue?: boolean;
  onChequeClick: (chequeId: string, tableId: string) => void;
  children: React.ReactNode;
  isSelected?: boolean;
  hasMultipleTables?: boolean;
}

const ChequeBlockItem: React.FC<Props> = ({
  chequeId,
  tableId,
  gridColumnStart,
  offsetMinutes,
  durationMinutes,
  isPastDue,
  onChequeClick,
  children,
  isSelected,
  hasMultipleTables,
}) => {
  const chequeButton = useButton({
    onClick: () => onChequeClick(chequeId, tableId),
  });

  return (
    <OngoingChequeBlock
      gridColumnStart={gridColumnStart}
      offsetMinutes={offsetMinutes}
      durationMinutes={durationMinutes}
      isPastDue={isPastDue}
      isSelected={isSelected}
      data-cheque-block="true"
      {...chequeButton}>
      <Box display="flex" alignItems="center" gap="xs">
        {hasMultipleTables && (
          <Icon src={linkIcon} height="16px" width="16px" color="var(--colorWhite)" />
        )}
        {children}
      </Box>
    </OngoingChequeBlock>
  );
};

export default ChequeBlockItem;
